'use strict';

require('./assets/cookie-notification.css');
const utils = require('./utils/utils');
const tsStart = new Date().getTime();

utils.reportBI('506');

function cookieNotification() {
  const userDetails = require('modules/userDetails');
  const geoValidator = require('modules/geoValidator');
  const visual = require('modules/visual');
  const locale = require('modules/locale');
  const language = userDetails.language();

  if (userDetails.sawNotification() || !userDetails.isAnonymous()) {
    utils.reportBI('509', ['confirmation=true']);
    return;
  }

  geoValidator.validate()
    .then(result => {
      if (!result.data.allowed) {
        utils.reportBI('508', ['required=0']);
        return;
      }

      utils.reportBI('508', ['required=1']);
      utils.reportBI('510');
      const ts = new Date().getTime();
      const data = {language, locale: locale.get(language)};
      visual.create(data, ts);
    })
    .catch(error => console.warn(error));
}

if (document.readyState === 'complete') {
  cookieNotification();
} else {
  window.addEventListener('load', cookieNotification);
}

utils.reportBI('507', [`delta=${new Date().getTime() - tsStart}`]);



// WEBPACK FOOTER //
// ./client.js